import LICENSE_INFORMATION_HOLDER_TYPES from '../constants/licenseInformationHolderTypes';
import LICENSE_INFORMATION_TYPE_DISPLAY_NAMES from '../constants/licenseInformationTypeDisplayNames';

export const LicenseInformationMapper = {
  toTableData: (licenseInformation, type) => {
    const holder = licenseInformationTypeToHolderProviderMap.get(type)(licenseInformation);
    return {
      type: type,
      typeDisplayName: LICENSE_INFORMATION_TYPE_DISPLAY_NAMES.get(type),
      paidAssigned: licenseInformation.PaidAssigned,
      paidTotal: licenseInformation.PaidTotal,
      paidTotalPlaceholder: licenseInformation.PaidTotal,
      freeAssigned: licenseInformation.FreeAssigned,
      freeTotal: licenseInformation.FreeTotal,
      freeTotalPlaceholder: licenseInformation.FreeTotal,
      ...holder
    };
  },

  toApolloInput: licenseInformations => {
    const orgnizationInput = getOrganizationInput(licenseInformations);
    const orgUnitsInput = getOrgUnitsInput(licenseInformations);

    return {
      Organization: orgnizationInput,
      OrgUnits: orgUnitsInput
    };
  }
};

const getOrganizationInput = licenseInformations => {
  const licenseInformation = licenseInformations.find(
    li => li.type === LICENSE_INFORMATION_HOLDER_TYPES.Organization
  );

  if (!licenseInformation) {
    return null;
  }

  return {
    OrgId: licenseInformation.holderId,
    PaidTotal: licenseInformation.paidTotal,
    FreeTotal: licenseInformation.freeTotal
  };
};

const getOrgUnitsInput = licenseInformations => {
  const orgUnitLicenseInformations = licenseInformations.filter(
    li => li.type === LICENSE_INFORMATION_HOLDER_TYPES.OrgUnit
  );
  if (!orgUnitLicenseInformations.length) {
    return null;
  }

  return orgUnitLicenseInformations.map(li => ({
    OrgUnitId: li.holderId,
    PaidTotal: li.paidTotal,
    FreeTotal: li.freeTotal
  }));
};

const licenseInformationTypeToHolderProviderMap = new Map([
  [
    LICENSE_INFORMATION_HOLDER_TYPES.Organization,
    licenseInformation => ({
      holderId: licenseInformation.OrgId,
      holderName: licenseInformation.OrgName
    })
  ],
  [
    LICENSE_INFORMATION_HOLDER_TYPES.OrgUnit,
    licenseInformation => ({
      holderId: licenseInformation.OrgUnitId,
      holderName: licenseInformation.OrgUnitName
    })
  ]
]);
